import React, { useContext, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Observer } from "mobx-react-lite";

import NaocDailyProductionStore from "../../../../store/naocdailyproductionstore";

import { toJS } from "mobx";
import moment from "moment";
import { Button, Radio, Space, Switch, Tooltip } from "antd";
import {
  BarChartOutlined,
  BarsOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
import useHover from "react-use-hover";
import { useToggle } from "../../../../../../Utility/modules/helpers";
import { Settings } from "react-feather";
export const RythmChart = React.forwardRef((props, ref) => {
  const [chartType, setChartType] = useState("line");
  const [showLabel, setShowLabel] = useState(false);
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  console.log("props is", props.type);
  const [isClicked, setClicked] = useToggle();
  let data = [];

  switch (props.dataType) {
    case "production":
      switch (props.type) {
        case "Oil":
          data = [...naocDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.totalOilProduced)
          );
          break;
        case "Gas":
          data = [...naocDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.totalGasProduced)
          );
          break;
        case "NGL":
          data = [...naocDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.nglProduced)
          );
          break;
        case "Boe":
          data = [...naocDailyProductionStore.dailyProductions.values()].map(
            (x) =>
              toJS(x.nglProduced + x.totalOilProduced + x.totalGasProduced / 6)
          );
          break;

        default:
          break;
      }
      break;
    case "evacuation":
      switch (props.type) {
        case "Oil":
          data = [...naocDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.totalOilProduced)
          );
          break;
        case "Gas":
          data = [...naocDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.totalGasEvacuated)
          );
          break;
        case "NGL":
          data = [...naocDailyProductionStore.dailyProductions.values()].map(
            (x) => toJS(x.nglDelivered)
          );
          break;
        case "Boe":
          data = [...naocDailyProductionStore.dailyProductions.values()].map(
            (x) =>
              toJS(
                x.nglDelivered + x.totalOilProduced + x.totalGasEvacuated / 6
              )
          );
          break;

        default:
          break;
      }
      break;

    default:
      break;
  }

  return (
    <Observer>
      {() => (
        <>
          <Tooltip title="apply  more chart settings...">
            <div
              onClick={setClicked}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                cursor: "pointer",
                padding: "5px",
              }}
            >
              <Settings size="16" color="#6c757d" />
            </div>
          </Tooltip>

          <div className="ms-Grid" dir="ltr">
            <div
              className="ms-Grid-row"
              style={{
                display: isClicked ? "flex" : "none",
              }}
            >
              <div
                className="ms-Grid-col ms-sm3"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  paddingLeft: "10px",
                  paddingTop: "10px",
                }}
              >
                <Switch
                  checkedChildren="Hide value labels"
                  unCheckedChildren="Show value labels"
                  defaultChecked={false}
                  onChange={(args) => {
                    setShowLabel(args);
                  }}
                />
              </div>
              <div
                className="ms-Grid-col ms-sm9"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "5px",
                  paddingRight: "10px",
                }}
              >
                <Radio.Group
                  defaultValue="line"
                  buttonStyle="solid"
                  onChange={({ target }) => {
                    setChartType(target.value);
                  }}
                >
                  <Radio.Button value="line">
                    <Tooltip placement="topLeft" title="switch to Line Chart">
                      <LineChartOutlined />
                    </Tooltip>
                  </Radio.Button>
                  <Radio.Button value="column">
                    <Tooltip placement="topLeft" title="switch to Column Chart">
                      <BarChartOutlined />{" "}
                    </Tooltip>
                  </Radio.Button>
                  <Radio.Button value="bar">
                    <Tooltip placement="topLeft" title="switch to Bar Chart">
                      <BarsOutlined />
                    </Tooltip>
                  </Radio.Button>
                </Radio.Group>
              </div>
            </div>
          </div>

          <HighchartsReact
            ref={ref}
            highcharts={Highcharts}
            options={{
              chart: {
                type: chartType,
              },
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },

              title: {
                text: props.title,
                style: { fontSize: "14px" },
              },

              xAxis: {
                categories: [
                  ...naocDailyProductionStore.dailyProductions.values(),
                ].map((x) => toJS(x.productionDate)),
                crosshair: true,
                title: {
                  text: "Production",
                },
                labels: {
                  formatter: (args) => moment(args.value).format("MMM DD"),
                },
              },
              yAxis: {
                min: 0,
                title: {
                  text: props.seriesName,
                },
              },
              tooltip: {
                headerFormat:
                  '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat:
                  '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y:.1f} bopd</b></td></tr>',
                footerFormat: "</table>",
                shared: true,
                useHTML: true,
              },
              plotOptions: {
                column: {
                  pointPadding: 0.2,
                  borderWidth: 0,
                },
              },
              series: [
                {
                  name: props.seriesName,
                  data,
                  color: props.fluidColor,

                  dataLabels: {
                    enabled: showLabel,
                    formatter: function () {
                      if (this.y > 1000000) {
                        return (
                          Highcharts.numberFormat(this.y / 1000000, 3) + "M"
                        );
                      } else if (this.y > 1000) {
                        return Highcharts.numberFormat(this.y / 1000, 3) + "K";
                      } else {
                        return this.y;
                      }
                    },
                  },
                },
              ],
              responsive: {
                rules: [
                  {
                    condition: {
                      maxWidth: 1000,
                    },
                    chartOptions: {
                      legend: {
                        floating: false,
                        layout: "horizontal",
                        align: "center",
                        verticalAlign: "bottom",
                        x: 0,
                        y: 0,
                      },
                      yAxis: [
                        {
                          labels: {
                            align: "right",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          labels: {
                            align: "left",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          visible: false,
                        },
                      ],
                    },
                  },
                ],
              },
            }}
          />
        </>
      )}
    </Observer>
  );
});

